import { isAuthorized } from './tokenUtils';
import { isFeatureEnabled } from './featureUtils'
import { favoriteStyle, unfavoriteStyle } from '../actions/favoritesActions';

/**
 * @return True if the favorites feature is active
 */
export function isFavoritesEnabled() {
    return isFeatureEnabled("favorites");
}

export function createFavoriteLookupKeyForStyle(style) {
    const { styleNumber } = style;
    const key = `${styleNumber}`;

    return key;
}

/**
 * Favorites icon clicked, to favorite or not to favorite
 * @param store Redux store
 * @param e Click/touch event
 */
export function favoriteClicked(store, e) {
    e.preventDefault();
    e.stopPropagation();

    // Race condition... how to solve...
    const favoriting = !$(e.currentTarget).hasClass('is-favorited');

    // Add the class here (also in listener saga) to make the UI appear responsive
    if (isAuthorized()) {
        $(e.currentTarget).toggleClass('is-favorited');
    }

    const productTile = $(e.target).parents('.js-product-tile');
    const styleNumber = productTile.attr('data-style-number');
    const productDisplayName = productTile.attr('data-product-name');

    if (favoriting) {
        store.dispatch(favoriteStyle(styleNumber, productDisplayName));
    } else {
        store.dispatch(unfavoriteStyle(styleNumber, productDisplayName));
    }

    return false;
}

/**
 * Update all the product tiles with the correct favorite/unfavorite selection
 * @param styleNumbersInGrid style number on the current grid
 * @param styles A set af all liked styles
 */
export function updateGridFavorites(styleNumbersInGrid, styles) {
    // Build a list of favorited and unfavorited styles on the page
    const favoritedStyles = new Set(styleNumbersInGrid.filter(x => styles.has(x)));
    const unfavoritedStyles = new Set(styleNumbersInGrid.filter(x => !styles.has(x)));

    favoritedStyles.forEach((styleNumber) => {
        favoriteTileStyle(styleNumber);
    });

    unfavoritedStyles.forEach((styleNumber) => {
        unfavoriteTileStyle(styleNumber);
    });
}

/**
 * Unfavorite a style number
 * @param styleNumber Style number of the unfavorited product
 */
export function unfavoriteTileStyle(styleNumber) {
    $(`div[data-style-number='${styleNumber}'] .js-favorite-toggle`).removeClass('is-favorited');
    $(`div[data-style-number='${styleNumber}'] .js-favorite-toggle`).removeAttr('data-qa-product-is-hearted');
}

/**
 * Like a style number
 * @param styleNumber Style number of the favorited product
 */
export function favoriteTileStyle(styleNumber) {
    $(`div[data-style-number='${styleNumber}'] .js-favorite-toggle`).addClass('is-favorited');
    $(`div[data-style-number='${styleNumber}'] .js-favorite-toggle`).attr('data-qa-product-is-hearted', '');
}

